var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 3.80665C12.44 3.54665 12.02 3.54665 11.76 3.80665L8.49998 7.05998L5.23998 3.79998C4.97998 3.53998 4.55998 3.53998 4.29998 3.79998C4.03998 4.05998 4.03998 4.47998 4.29998 4.73998L7.55998 7.99998L4.29998 11.26C4.03998 11.52 4.03998 11.94 4.29998 12.2C4.55998 12.46 4.97998 12.46 5.23998 12.2L8.49998 8.93998L11.76 12.2C12.02 12.46 12.44 12.46 12.7 12.2C12.96 11.94 12.96 11.52 12.7 11.26L9.43998 7.99998L12.7 4.73998C12.9533 4.48665 12.9533 4.05998 12.7 3.80665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseImageIcon);
export default __webpack_public_path__ + "static/media/closeImageIcon.7b8449c37291d4bb6489aae4a5915712.svg";
export { ForwardRef as ReactComponent };